module.exports = __webpack_public_path__ + "fonts/Inter-Regular.7c53993.woff";